export default __webpack_public_path__ + "static/media/flag.b8448523.png";